export default "__VITE_ASSET__$jyg2G29__"